import {IOccasionFilter} from "../../../domain/occasions/filters/IOccasionFilter";
import {Occasion} from "../../../../../../server/src/base/entities/occasion/Occasion";
import {RangeFilter} from "./abstract/RangeFilter";

export class PriceFilter implements IOccasionFilter{

    private rangeFilter:RangeFilter;

    constructor(){
        this.rangeFilter = new RangeFilter();
    }

    public IsValid(occasion: Occasion): boolean {
        return this.rangeFilter.IsValid(occasion.price);
    }

    public SetMinValue(price:number){
        this.rangeFilter.SetMin(price);
    }

    public SetMaxValue(price:number){
        this.rangeFilter.SetMax(price);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/occasions/filters/PriceFilter.ts